export const singleConfiguratorAjaxRequest = function (path, method = 'GET', queryParameter = {}, success = () => { }, failure = () => { }, body = {}) {
  const complete_path = 'cortona_rotoclear_configuratorbundle_single_configurator/' + window.language + "/" + path;
  ajaxRequest(complete_path, method, queryParameter, success, failure, body);
}
export const oldConfiguratorAjaxRequest = function (path, method = 'GET', queryParameter = {}, success = () => { }, failure = () => { }, body = {}) {
  const complete_path = "/api/rotoclearconfiguratorbundle/" + window.language + "/" + window.moduleId + "/" + path;
  ajaxRequest(complete_path, method, queryParameter, success, failure, body);
};
const ajaxRequest = function (path, method = 'GET', queryParameter = {}, success = () => { }, failure = () => { }, body = {}) {
  var xhr = new XMLHttpRequest();
  var urlParams = new URLSearchParams(queryParameter);
  xhr.onload = function () {
    // Process our return data
    if (xhr.status >= 200 && xhr.status < 300) {
      // This will run when the request is successful
      success(xhr);
    } else {
      // This will run when it's not
      failure(xhr);
    }
  }
  xhr.open(method, path + '?' + urlParams.toString());
  xhr.setRequestHeader('Accept-Language', "DE-de");
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xhr.send(JSON.stringify(body));
}